import { useEffect, useState } from "react";
import axios from 'axios';
import styled from "styled-components";
import fundo from "../../../../styles/fundo.svg";

import { SlSizeFullscreen } from "react-icons/sl";



// ========== LOOK & FEEL MINIMALISTA ==========
const palette = {
  // fundo da página (se usar)
  cardBg: "#ffffff",
  headBg: "#0a7a3f",          // cabeçalho da tabela
  headText: "#ffffff",
  text: "#334155",
  textMuted: "#64748b",
  border: "#e5e7eb",
  zebra: "#f8fafc",

  accent: "#0ea5e9",
};

// Container do card/tabela
const Geral = styled.div`
  overflow: hidden;
  background: ${palette.cardBg};
  border: 1px solid ${palette.border};
  border-radius: 14px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  margin: 10px auto;
  width: 100%;

  /* Envolve a tabela num scroller vertical suave */
  & > div {
    overflow: auto;
  }

  /* Scrollbar minimal */
  & > div::-webkit-scrollbar {
    height: 10px;
    width: 10px;
  }
  & > div::-webkit-scrollbar-track {
    background: transparent;
  }
  & > div::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 999px;
  }
  & > div::-webkit-scrollbar-thumb:hover {
    background: #c4c9d1;
  }

  @media (max-width: 1367px) {
    margin: 8px;
    box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);
  }

  @media (max-width: 1024px) {
    margin: 8px;
    margin-bottom: 100px;
  }
`;

// Tabela
const Table = styled.table`
  border-collapse: collapse;   /* 👈 junto com as bordas fica linear */
  width: 100%;
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto,
    "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif;


  /* borda inferior de cada linha do corpo */
  tbody tr:not(:last-child) td {
    border-bottom: 1px solid ${palette.border};
  }
`;

// Cabeçalho sticky com fallback de cor
const Thead = styled.thead`
  position: sticky;
  top: 0;
  z-index: 5;
  background-color: ${palette.headBg};
  background-blend-mode: multiply;
  backdrop-filter: saturate(120%) blur(2px);
`;

// Linhas
export const Tr = styled.tr`
  /* ❌ remova esta linha:
  border-bottom: 1px solid ${palette.border};
  */

  ${({ noHover }) =>
    !noHover &&
    `
    &:hover {
      background-color: ${palette.zebra}; /* ou outra cor de hover */
    }
  `}

  @media (max-width: 1024px) {
    .hide-on-mobile {
      display: none;
    }
  }
`;

// Cabeçalho das colunas
export const Th = styled.th`
  color: ${palette.headText};
  padding: clamp(8px, 1.6vw, 14px) clamp(6px, 1.4vw, 10px);
  font-size: clamp(8px, 1.2vw, 11px);
  text-align: center;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  border-bottom: 1px solid rgba(255,255,255,0.08);
  white-space: nowrap;

  &.hide-on-mobile {
    @media (max-width: 1024px) {
      display: none;
    }
  }

  .tooltip {
    position: relative;
    cursor: help;
  }
  .tooltip .tooltiptext {
    visibility: hidden;
    width: max-content;
    background-color: #111827;
    color: #fff;
    text-align: left;
    border-radius: 8px;
    padding: 4px 8px;
    position: absolute;
    z-index: 10;
    bottom: 125%;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    transition: opacity .2s ease;
    white-space: nowrap;
    box-shadow: 0 8px 20px rgba(0,0,0,.2);
  }
  .tooltip:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }
`;

// Células
export const Td = styled.td`
  padding: clamp(10px, 1.8vw, 16px) clamp(6px, 1.4vw, 10px);
  text-align: ${(props) => (props.alignCenter ? 'center' : 'left')};
  font-size: clamp(8px, 1.4vw, 11px);
  color: ${palette.text};
  background-color: ${(props) => (props.zebra ? palette.zebra : "transparent")};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &.mobile-hide {
    @media (max-width: 1024px) {
      display: none;
    }
  }
`;

const FooterNote = styled(Td)`
  /* sobrescreve o Td padrão para permitir quebra */
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  overflow: visible;
  text-overflow: initial;

  border-top: 2px solid ${palette.border};
  color: ${palette.textMuted};
  line-height: 1.35;

  /* desktop base */
  font-size: 12px;
  padding: 12px;

  /* tablets */
  @media (max-width: 780px) {
    font-size: 11px;
    padding: 10px;
  }

  /* mobile estreito (até ~500px) */
  @media (max-width: 500px) {
    font-size: 10px;
    padding: 8px;
  }
`;


// Corpo
export const Tbody = styled.tbody`
  background-color: #fff;
`;

// TH que funciona como “cabeçalho-título” (linha 1)
export const CabecalhoTabela = styled.th`
  text-align: center;
  padding: clamp(10px, 2vw, 18px);
  color: ${palette.headText};
  background-color: ${palette.headBg};
  position: sticky;
  top: 0;
  z-index: 6; /* acima do Thead */
  border-bottom: 1px solid rgba(255,255,255,0.08);

  h2 {
    margin: 0;
    font-size: clamp(14px, 2.4vw, 18px);
    font-weight: 700;
    letter-spacing: 0.01em;
  }
`;

// Botão “fantasma” no header (usado para ícones)
const Button = styled.td`
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  background-color: transparent;
  color: ${palette.headText};
  opacity: .9;
  transition: transform .12s ease, opacity .12s ease;
  user-select: none;

  &:hover { transform: translateY(-1px); opacity: 1; }
  &:active { transform: translateY(0); opacity: .85; }

  @media (max-width: 780px) {
    font-size: 14px;
  }
`;

// Header do título/ações
const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 12px;

  @media (max-width: 780px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;

    h2 { font-size: clamp(16px, 5vw, 20px); }
  }
`;

const HeaderRight = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;

  p {
    margin: 0;
    font-size: 12px;
    color: ${palette.headText};
    opacity: .85;
  }

  @media (max-width: 780px) {
    width: 100%;
    justify-content: space-between;
    p { font-size: 11px; }
  }
`;

const IconGroup = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;

  /* alvo o <td> Button que contém ícones */
  ${Button} {
    padding: 6px 8px;
    border-radius: 10px;
    background: rgba(255,255,255,0.06);
    border: 1px solid rgba(255,255,255,0.08);
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: flex-start;

  @media (max-width: 1024px) {
    flex-direction: column; /* 👈 empilha no mobile */
  }
`;



const useBoletim = (tipo, urlApi, rota = "atualiza-20-minutos") => {
  const [dados, setDados] = useState([]);

  useEffect(() => {
    const fetchDados = async () => {
      try {
        const res = await axios.get(`${urlApi}boletins-externo/${rota}/${tipo}`);
        setDados(res.data);
      } catch (error) {
        console.error(`Erro ao buscar ${tipo}:`, error);
      }
    };

    fetchDados();
  }, [tipo, urlApi, rota]);

  return dados;
};
const Grid = ({ urlApi }) => {



  //=========================== Atualiza a cada 20 minutos ==============================//
  const dataCabecalho = useBoletim("cabeçalho", urlApi);

  const horaQueRodou = useBoletim("hora-rodou", urlApi);
  const entradaCanaPorHora = useBoletim("entrada-por-hora", urlApi);
  const moagemCanaPorHora = useBoletim("moagem-por-hora", urlApi);
  const entradaCanaMoagemHoje = useBoletim("entrada-cana-moagem-hoje", urlApi);
  const entradaCanaMoagemOntem = useBoletim("entrada-cana-moagem-ontem", urlApi);









  //===========================TELA CHEIA==============================//
  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => {
        console.log(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
      });
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  };


  // Junta HOJE e ONTEM em um único array
  const entradaCanaMoagem = entradaCanaMoagemHoje.map(itemHoje => {
    const itemOntem = entradaCanaMoagemOntem.find(item => item.TOTAL === itemHoje.TOTAL);
    return {
      TOTAL: itemHoje.TOTAL,
      HOJE: itemHoje.HOJE ?? 0,
      ONTEM: itemOntem?.ONTEM ?? 0,
    };
  });


  return (
    <Container>
      <Geral >

        {horaQueRodou != null && (
          <>
            <Table>
              <Thead>
                <Tr noHover>
                  <CabecalhoTabela colSpan={13}>
                    <HeaderWrapper>
                      <h2 >Média</h2>
                      <HeaderRight>
                        <p >Atualizado: {horaQueRodou.hora}</p>
                        <IconGroup>

                        </IconGroup>
                      </HeaderRight>
                    </HeaderWrapper>
                  </CabecalhoTabela>
                </Tr>


                {dataCabecalho?.map((item, index) => (
                  <Tr key={index} noHover>
                    <Th style={{ width: '20%' }}>Descrição</Th>
                    <Th style={{ width: '20%', textAlign: 'center' }}>
                      {new Date(item.ONTEM).toLocaleDateString("pt-BR", {
                        timeZone: "America/Sao_Paulo",
                        day: "2-digit",
                        month: "2-digit",
                        year: "2-digit", // 👈 aqui muda o ano para 2 dígitos
                      })}
                    </Th>
                    <Th style={{ width: '20%', textAlign: 'center' }}>
                      {new Date(item.HOJE).toLocaleDateString("pt-BR", {
                        timeZone: "America/Sao_Paulo",
                        day: "2-digit",
                        month: "2-digit",
                        year: "2-digit",
                      })}
                    </Th>
                  </Tr>
                ))}

              </Thead>



              <Tbody>
                {entradaCanaMoagem?.map((item, index) => (
                  <Tr key={index}>
                    <Td style={{ textAlign: 'start' }}><strong>{item.TOTAL}</strong></Td>
                    <Td style={{ textAlign: 'center' }}>
                      {item.ONTEM === 0 ? '-' : item.ONTEM}
                    </Td>
                    <Td style={{ textAlign: 'center' }}>{item.HOJE}</Td>
                  </Tr>
                ))}
              </Tbody>

              <tfoot>
                <Tr noHover>
                  <FooterNote colSpan={3}>
                    <strong>Fórmula teórica:</strong><br />
                    Moagem Hora = (60 × RPM Moenda) – (30 × %Fibra) + 460<br />
                    RPM Moenda = RPM Turbina ÷ 873<br />
                    *Caso não haja análise de fibra para o dia, utiliza-se a fibra média do dia anterior
                  </FooterNote>
                </Tr>
              </tfoot>



            </Table>





          </>

        )}
      </Geral>
      <Geral>

        {horaQueRodou != null && (
          <>

            <Table>
              <Thead>
                <Tr noHover>
                  <CabecalhoTabela colSpan={13}>
                    <HeaderWrapper>
                      <h2 >Entrada de Cana por Hora</h2>
                      <HeaderRight>
                        <p >Atualizado: {horaQueRodou.hora}</p>
                        <IconGroup>

                        </IconGroup>
                      </HeaderRight>
                    </HeaderWrapper>
                  </CabecalhoTabela>
                </Tr>


                {dataCabecalho?.map((item, index) => (
                  <Tr key={index} noHover>
                    <Th style={{ width: '20%' }}>{item.HORA}</Th>
                    <Th style={{ width: '20%' }}>
                      {new Date(item.ONTEM).toLocaleDateString("pt-BR", {
                        timeZone: "America/Sao_Paulo",
                        day: "2-digit",
                        month: "2-digit",
                        year: "2-digit", // 👈 aqui muda o ano para 2 dígitos
                      })}
                    </Th>
                    <Th style={{ width: '20%' }}>
                      {new Date(item.HOJE).toLocaleDateString("pt-BR", {
                        timeZone: "America/Sao_Paulo",
                        day: "2-digit",
                        month: "2-digit",
                        year: "2-digit",
                      })}
                    </Th>
                  </Tr>
                ))}

              </Thead>


              <Tbody>
                {entradaCanaPorHora?.map((item, index) => (
                  <Tr key={index}>
                    <Td style={{ textAlign: 'center' }}>{item.HORA}</Td>
                    <Td style={{ textAlign: 'center' }}>{item.ONTEM}</Td>
                    <Td style={{ textAlign: 'center' }}>{item.HOJE}</Td>
                  </Tr>
                ))}
              </Tbody>




            </Table>



          </>

        )}
      </Geral>
    </Container >
  );
};



export default Grid;
